const QUERIES = {
  USERS_LIST: 'users-list',
  LINKS_LIST: 'links-list',

}

export {QUERIES}
